const organization_en = require('./organization.json')
export default organization_en